var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":function($event){return _vm.toggleItem()}}},[_vm._v("\n    "+_vm._s(this.isOn ? this.onLabel : this.offLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }